import { useSearchParams } from 'react-router-dom'
import { useProject } from 'context/ProyectoContext'
import { useStats } from 'hooks/useStats'
import { useTiposDiff } from 'hooks/userTiposDiff'

import React, { useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import AnalyzedCategories from './AnalyzedCategories'
import { CustomButton } from 'components/ui'

import { DatosPage_v2 } from './DatosPage_v2'
import { DatosCards } from './DatosCards'


const DatosPage = () => {
  let [searchParams] = useSearchParams()
  const [isBoq, setIsBoq] = useState(false)
  const [currentProgress, setCurrentProgress] = useState(0)

  // Traemos el proyecto y versiones desde el contexto
  const { currentProject, versions, isLoadingCurrentProject: isLoading } = useProject()

  // Obtenemos la versión desde los query params (o la última si no existe param)
  const version = searchParams.get('version')
    ? searchParams.get('version')
    : versions.length

  
  const { data: stats, isLoading: isLoadingStats } = useStats(currentProject._id, version)
  const { data: tiposDiff, isLoading: isLoadingTiposDiff } = useTiposDiff(currentProject._id, version)

  
  useEffect(() => {
    fetch(`/api/boq/${currentProject._id}/hasversion/${version}`)
      .then(res => res.json())
      .then(res => setIsBoq(res.hasVersion))
  }, [version, currentProject._id])

  // Reiniciar el progreso cada vez que cambian las stats
  useEffect(() => {
    setCurrentProgress(0)
  }, [stats])

  
  useEffect(() => {
    if (!isLoadingStats && stats?.progress) {
      let animation
      if (currentProgress < stats.progress) {
        animation = setInterval(() => {
          setCurrentProgress(prev => {
            const nextValue = prev + 0.05
            return nextValue >= stats.progress ? stats.progress : nextValue
          })
        }, 50)
      }
      return () => clearInterval(animation)
    }
  }, [currentProgress, stats?.progress, isLoadingStats])

  const handleCreateBoQ = () => {
    alert('Crear las boqs con la versión actual\nExactamente igual que en el módulo Fábrica')
  }


  // Si el proyecto está cargando, mostramos algo de feedback (spinner, texto, skeleton, etc.)
  if (isLoading) return <div>Cargando...</div>

  return (
    <div className="scroll-container">
      <div className="datos-page-container" style={{ position: 'relative' }}>
        {/* Si no hay BoQ para esta versión, se ofrece crearlo */}
        {!isBoq && (
          <CustomButton
            type="secondary"
            className="btn-center"
            onClick={handleCreateBoQ}
          >
            <AddIcon /> Generar BoQs para la versión {version}
          </CustomButton>
        )}
        <br />
          
        {/* Tabla con datos básicos del proyecto */}
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div className="table-datos-page-container">
            <DatosPage_v2 />
          </div>
        </div>
            
          {/* Tarjetas con estadísticas del proyecto */}
          
        <DatosCards isLoadingStats={isLoadingStats} stats={stats} currentProgress={currentProgress} />

            
        {/* Análisis de Categorías */}
        <AnalyzedCategories isLoadingStats={isLoadingStats} stats={stats} />

        
        <div className="categories-tipos">
          <h2 className="card-title">Análisis tipos:</h2>
          {isLoadingTiposDiff ? (
            <div>
              <Skeleton height={20} width="60%" style={{ marginBottom: '1rem' }} />
              <Skeleton height={20} width="80%" />
            </div>
          ) : (
            <div className="card-message-wrapper">
              <span className="card-message">
                
                {tiposDiff ? tiposDiff.message : '(Sin datos)'}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DatosPage
